import "./App.css";

import Mosques from "./components/mosques/mosques";


import Main from "./components/main/main";
import { Routes, Route, useLocation } from "react-router";
import Test from "./test";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import instance from "./axios";
import { setCurrentUser } from "./redux/reducers/userSlice";
import AddAnnouncement from "./components/addAnnouncement/addAnnouncement";
import Announcement from "./components/announcement/announcement";
import MyAds from "./components/myAds/index";
import AllMosqueAds from "./components/all-mosque-ads/AllMosqueAds";
import Notifications from "./components/notifications/Notifications";
import MosqueInfo from "./components/mosque-info/MosqueInfo";
import Announcements from "./components/announcements/Announcements";
import Help from "./components/help/help";


/*
http://147.182.187.59:6558/api/categories/tg
http://147.182.187.59:6558/api/mosques/tg
http://147.182.187.59:6558/api/ads

 http://147.182.187.59:6558/api/ads?mosque=365646 » get mosque ads
http://147.182.187.59:6558/api/ads?user=46556 » get category ads » bu array bo'lishi kerak

*/

function App() {
  
  // const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
    ? window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
    : "1598016165";

  const location = useLocation();
  // get current user
  useEffect(() => {
    instance
      .get(`api/users/tg/${tgId}`, {
        headers: {
          Authorization: `Telegram ${tgId}`,
        },
      })
      .then((res) => {
        if (res?.data?.data?.user) {
          dispatch(setCurrentUser(res?.data?.data?.user));
        }
      });
  }, []);

  //----------------This code hides telegrams main button---------------------------///
  if (location.pathname.slice(0, 14) === "/announcement/") {
    window.Telegram.WebApp.MainButton.isVisible = true;
    window.Telegram.WebApp.MainButton.text = "Telefon raqamdan nusxa olish!!";
    window.Telegram.WebApp.MainButton.color = "#55BE61";
  } else {
    window.Telegram.WebApp.MainButton.isVisible = false;
  }

  // window.Telegram.WebApp.MainButton.isVisible = false;
  //-------------------------------------------///


  return (
    <div className="bg-grayy min-h-screen ">
      {/* <NavBar /> */}

        <Routes>
          <Route path="/" element={<Main/>}/>
          <Route path="/mosques" element={<Mosques/>}/>
          <Route exact path="/myads" element={<MyAds />} />
          <Route
            exact
            path="/mosque-ads/:mosqueIdAds"
            element={<AllMosqueAds />}
          />
          <Route path="/add-announcement" element={<AddAnnouncement/>}/>
          <Route exact path="/notifications" element={<Notifications />} />
          <Route path="/announcement/:id" element={<Announcement/>}/>
          <Route exact path="/mosque-info/:mosqueId" element={<MosqueInfo />} />
          <Route exact path="/announcements" element={<Announcements />} />
          <Route exact path="/announcement/:id/help" element={<Help />} />
          <Route
            path="*"
            element={
              <div className="container mx-auto p-2">
                <h1 className="text-3xl text-red-600 text-center">
                  Mavjud emas...
                </h1>
              </div>
            }
          />

          {/* ////////////// */}
          <Route path="/test" element={<Test/>}/>
        </Routes>
    </div>
  );
}

export default App;
